module.exports = __webpack_public_path__ + "img/IT-Systemelektroniker.68681834.png";